module.exports = __webpack_public_path__ + "media/audio2.a2935ae2.mp3";